import { ADMIN } from "../constants/auth";

export const getToken = () => {
  return localStorage.getItem("authorization");
};

export const isAdmin = (role) => {
  return role === ADMIN;
};
